export const breakpoints = (size) => {
  switch (size) {
    case 'xs': return 480;
    case 'sm': return 768;
    case 'md': return 992;
    case 'lg': return 1024;
    case 'xl': return 1440;

    default: return size;
  }
};

const media = (size, args = {}) => {
  const {
    isMax,
    isCamelCase,
  } = args;

  let bp = breakpoints(size);
  const type = isMax ? 'max' : 'min';

  if (isMax) bp -= 1;

  return isCamelCase ?
    `@media(${type}Width: ${bp}px)`
    :
    `@media(${type}-width: ${bp}px)`;
};

export default media;



// WEBPACK FOOTER //
// ./src/styles/media.js